import { Box, ResponsiveContext } from "grommet";
import CenteredColumn from "../components/CenteredColumn";
import PageHeader from "../components/PageHeader";
import { useContext } from "react";
import { PortableText } from "@portabletext/react";
import AppContext from "../stateManager/appContext";
import styled from "styled-components";

const StyledBox = styled(Box)`
  p {
    padding: 0.5rem;
  }
`;

const FaqsPage = () => {
  const viewportSize = useContext(ResponsiveContext);
  const { siteData } = useContext(AppContext);
  if (!siteData) {
    return null;
  }

  return (
    <Box>
      <PageHeader label={siteData.faqsPage.title} />

      <CenteredColumn columnWidth="xxlarge" pad={{ horizontal: "large" }}>
        <Box
          gap="medium"
          direction={viewportSize === "small" ? "column-reverse" : "row"}
          justify="center"
          pad={{ vertical: "medium" }}
        >
          <Box
            width={"large"}
            height={"large"}
            alignSelf="center"
            round="small"
            background={{
              image: "url(" + siteData.faqsPage.imageUrl + ")",
              position: "center",
            }}
          ></Box>
          <StyledBox>
            <PortableText value={siteData.faqsPage.Content} />
          </StyledBox>
        </Box>
      </CenteredColumn>
    </Box>
  );
};
export default FaqsPage;
